import { useEffect, useMemo, useState } from 'react'
import { BulbOutlined } from '@ant-design/icons'
import { Select } from 'antd'

import { findCheckSuggestions } from '../../common/request'
import ResponseCode from '../../common/response-code'
import Styles from './CheckSuggestionInputHints.module.scss'

/** 审核不通过原因 - 机构审核建议快捷输入 */
function CheckSuggestionInputHints ({ orgId, onSelect, resetKey = 0 }) {
  const [checkSuggestions, setCheckSuggestions] = useState([])
  const [selectKey, setSelectKey] = useState(0)

  useEffect(() => {
    if (!orgId) {
      setCheckSuggestions([])
      return
    }

    findCheckSuggestions({ orgId, status: 1 }).then(res => {
      if (res.code === ResponseCode.success) {
        setCheckSuggestions(Array.isArray(res.data) ? res.data : [])
      } else {
        setCheckSuggestions([])
      }
    }).catch(err => {
      console.error(err)
      setCheckSuggestions([])
    })
  }, [orgId])

  useEffect(() => {
    setSelectKey((key) => key + 1)
  }, [resetKey])

  const options = useMemo(() => {
    return checkSuggestions
      .filter(item => item.suggestion)
      .map(item => ({
        value: String(item.id),
        label: item.suggestion
      }))
  }, [checkSuggestions])

  const handleChange = (value) => {
    if (value == null || value === '') {
      return
    }

    const selected = checkSuggestions.find(item => String(item.id) === String(value))
    if (selected?.suggestion) {
      onSelect?.(selected.suggestion)
    }
    setSelectKey((key) => key + 1)
  }

  if (options.length === 0) {
    return null
  }

  return (
    <div className={ Styles.prompts }>
      <div className={ Styles.header }>
        <div className={ Styles.title }>
          <BulbOutlined style={ { marginRight: 6, color: '#1677ff' } } />
          快捷填写建议
        </div>
        <Select
          key={ `check-suggestion-select-${ selectKey }` }
          className={ Styles.select }
          showSearch
          allowClear
          placeholder="搜索并选择审核建议"
          options={ options }
          optionFilterProp="label"
          filterOption={ (input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.trim().toLowerCase())
          }
          optionRender={ (option) => (
            <div className={ Styles.option } title={ option.label }>{ option.label }</div>
          )}
          onChange={ handleChange }
        ></Select>
      </div>
    </div>
  )
}

export default CheckSuggestionInputHints
